export const sheetIcons = [
  "default-icon",
  "icon-01",
  "icon-02",
  "icon-03",
  "icon-04",
  "icon-05",
  "icon-06",
  "icon-07",
  "icon-08",
  "icon-09",
  "icon-10",
  "icon-11",
  "icon-12",
  "icon-13",
  "icon-14",
  "icon-15",
  "icon-16",
  "icon-17",
  "icon-18",
  "icon-19",
  "icon-20",
  "icon-21",
  "icon-22",
  "icon-23",
  "icon-24",
  "icon-25",
  "icon-26",
  "icon-27",
  "icon-28",
  "icon-29",
  "icon-30",
  "icon-31",
  "icon-32",
  "icon-33",
  "icon-34",
  "icon-35",
  "icon-36",
  "icon-37",
  "icon-38",
  "icon-39",
  "icon-40",
  "icon-41",
  "icon-42",
  "icon-43",
  "icon-44",
  "icon-45",
  "icon-46",
  "icon-47",
  "icon-48",
  "icon-49",
  "icon-50",
  "icon-51",
  "icon-52",
  "icon-53",
  "icon-54",
  "icon-55",
  "icon-56",
  "icon-57",
  "icon-58",
  "icon-59"
]

export const sheetColors = ["#1989FA", "#9A59FF", "#FDA23F"]

export const operations = [
  {
    label: "新建",
    value: "C"
  },
  {
    label: "编辑",
    value: "U"
  },
  {
    label: "删除",
    value: "D"
  },
  {
    label: "导入",
    value: "I"
  },
  {
    label: "导出",
    value: "E"
  },
  {
    label: "刷新（管理员权限）",
    value: "CALC"
  },
  {
    label: "打印",
    value: "P"
  },
  {
    label: "复制",
    value: "CP"
  },
  {
    label: "锁定解锁",
    value: "LK"
  },
  {
    label: "讨论",
    value: "DC"
  },
  {
    label: "更换负责人",
    value: "TL"
  },
  {
    label: "编辑团队成员",
    value: "TM"
  },
  {
    label: "查看日志",
    value: "LOG"
  },
  {
    label: "查看审批历史",
    value: "HIS"
  }
]

export const infoMenu = [
  { label: "基本信息", value: "base", icon: "base" },
  { label: "功能开关", value: "switch", icon: "switch" },
  { label: "高级设置", value: "setting", icon: "setting" },
  { label: "弹窗布局", value: "dialog", icon: "dialog" }
]
